import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import axios from "axios";
import { LanguageProvider } from "./utils/LanguageContext";
import cookie from "./utils/Cookie-utils";

axios.defaults.baseURL = "https://in-gift.herokuapp.com";
if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  axios.defaults.baseURL = "http://localhost:8080";
}

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    console.log("error.response", error.response);
    if (error.response && 401 === error.response.status) {
      localStorage.setItem("login_cb", window.location.pathname);
      window.location.href = window.location.origin;
    }
    return Promise.reject(error);
  },
);

axios.interceptors.request.use(
  (config) => {
    config.headers.language = localStorage.currentLanguageCode
      ? localStorage.currentLanguageCode
      : "fr";
    if (!config.headers.common || !config.headers.common.Authorization) {
      const token = cookie.getItem("ingift_token");
      if (token) {
        config.headers.Authorization = `JWT ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

const root = createRoot(document.getElementById("root"));
root.render(
  <LanguageProvider>
    <App />
  </LanguageProvider>,
);
